import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from '@mui/material';

type ConfirmationBeforeRemoveModalProps = {
  title: string;
  content: string;
  open: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
};

export const ConfirmationBeforeRemoveModal = ({
  title,
  content,
  open,
  confirmButtonText = 'Continue',
  cancelButtonText = 'Cancel',
  onConfirm,
  onCancel,
  onClose,
}: ConfirmationBeforeRemoveModalProps) => {
  const { tokens } = useTheme<LensTheme>();
  const color = tokens.semantic.color;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button
          data-testid="cancel-remove-document-confirm"
          variant="outlined"
          size="medium"
          onClick={onCancel}
        >
          {cancelButtonText}
        </Button>
        <Button
          data-testid="confirm-remove-documents"
          sx={{
            backgroundColor: color.action.destructive.default.value,
            color: color.action.destructive.onDestructive.value,
            '&:not(.Mui-disabled):hover': {
              backgroundColor: color.action.destructive.hover.value,
            },
          }}
          variant="contained"
          size="medium"
          onClick={onConfirm}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
